import { mapGetters } from 'vuex';
import { personalCenterMenu, routerArr } from '@/utils/default-data.js';

export default {
  data() {
    return {
      menuList: [],
      activeItem: '/person-center/account-info/member-info',
      isShowSideBar: true
    };
  },
  watch: {
    $route () {
      this.setIsShowSideBar();
      this.setActiveItem();
      this.getpersonalCenterMenu();
    }
  },
  created () {
    this.menuList = personalCenterMenu.slice(1, personalCenterMenu.length-1);
    if(this.userInfo.type !== 1) {
      this.menuList.forEach(item => {
        if(item.name === '我的服务订单') {
          item.children.push({
            name: '我的报备信息',
            path: '/person-center/partner-info'
          });
        }
      });
    };
    this.setIsShowSideBar();
    this.setActiveItem();
    this.getpersonalCenterMenu();
    if(location.href.indexOf('#reloaded')===-1){
      location.href=location.href+'#reloaded';
      location.reload();
    }
  },
  beforeUpdata() {
    console.log(111);
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    getpersonalCenterMenu() {
      if(this.userInfo.type !== 3 && this.menuList[6]) {
        this.menuList[6].children=[{
          name: '我的资产',
          path: '/person-center/my-assets/list'
        }];
      };
      if(this.userInfo.type !== 1) {
        this.menuList.forEach(item => {
          if(item.name === '我的托管业务') {
            this.menuList.splice(5, 1);
          }else {
          }
        });
      };
    },
    setActiveItem() {
      this.activeItem = this.$route && this.$route.path;
    },
    setIsShowSideBar () {
      const route = this.$route;
      // 是否展示侧边栏
      if(routerArr.find(item => {
        return route.path.indexOf(item) !== -1;
      })) {
        this.isShowSideBar = false;
      } else {
        this.isShowSideBar = true;
      }
    },
    // 路由跳转
    toPath(child) {
      if (child.path) {
        this.$router.push(child.path);
      }
    }
  }
};

